module.exports = __webpack_public_path__ + "img/cross4blue.dc1f15df.png";